import { publicGalleryURL } from "../constants/webConfig";
import { normalizeEmployee } from "./normalizeEmployee";

export function normalizeNews(news) {
    return {
        ...news,
        backgroundImage: `${publicGalleryURL}${news.backgroundImage?.data?.attributes?.url}`,
        author: normalizeEmployee(news?.author?.data?.attributes),
    }
}